// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> amc-preferred-theme-preferred -> fortyone-one-one
// Generated: 2026-10-08T21:31:33.901Z
// Counts: 1 design, 67 content, 41 slot group, 6 collection binding, 7 section, 1 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability and Pricing</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At FortyOne 11 in Portland, OR, vibrant city life meets cozy living. Choose from studio, one-, or two-bedroom floor plans and immerse yourself in a neighborhood rich with culture. Enjoy nearby gems like Powell's City of Books, the Portland Japanese Garden, and Multnomah County Central Library.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.javascript_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_apartmentsync_javascript_id"
  },
  "apply-now-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to make <span data-type=\"field-token\" data-field=\"property_name\"></span> your new home? Start your application online to take the next step toward finding an apartment that fits your needs. Complete the application below to get started.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.site_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "the",
    "generatedValue": null,
    "mappedField": "custom_audioeye_site_hash"
  },
  "feeguide.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Fee Guide</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.label": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments</p>",
    "generatedValue": null,
    "mappedField": "property_bedrooms_range"
  },
  "floorplanslist.starting_at": {
    "overrideType": "VALUE",
    "customValue": "<p>Starting at $1,499</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Property Photos</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/lincoln-place-apartments-in-unit-laundry-loveland-co::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Experience the convenience of having in-unit laundry at Lincoln Place Apartments. Our Loveland, CO community offers modern living with top-notch amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Loveland, CO</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1><p>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.</p><h2><strong>Information We Collect</strong></h2><p>We collect information from visitors on our Web site through online requests including:</p><ul><li><p>Contact Requests</p></li><li><p>Schedule a Tour Requests</p></li></ul><p>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.</p><h2>How the Information is Used</h2><p>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. In addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.</p><h2><strong>Sharing of Personal Information</strong></h2><p>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.</p><h2><strong>Security</strong></h2><p>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.</p><h2><strong>Cookies</strong></h2><p>From time to time, we may send a \"cookie\" to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer's hard drive. A cookie can't read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.</p><h2><strong>Links to Outside Sites</strong></h2><p>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.</p><h2><strong>Removal from Our Mailing List</strong></h2><p>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.</p><h2><strong>Contacting Us</strong></h2><p>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span> in vibrant <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span>, our residents celebrate the sense of community and comfort we offer. Dive into our reviews and see what else our satisfied tenants have to say about life at <span data-type=\"field-token\" data-field=\"property_name\"></span>!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>FortyOne 11 is in Portland's King neighborhood, on the west edge of the Alberta Arts District. Nearby places include Eem, Alberta Carts, Natural Grocers, Portland Playhouse, Alberta Abbey, and King School Park.</p><p>TriMet Line 6 stops on Martin Luther King Jr Boulevard at the building. Lines 24, 44, and 72 are close by. The MAX Yellow Line stops at Overlook Park, about a mile away, and the Portland Streetcar A and B Loops are about 1.3 miles away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to FortyOne 11, named for the address, 4111 NE MLK — an apartment community in the heart of Portland, OR. With a variety of thoughtfully designed floor plans, including cozy studios, spacious one-bedrooms, and modern two-bedrooms, we have the perfect home for everyone. Each apartment features high-end finishes such as wood-style flooring, quartz countertops, and energy-efficient stainless-steel appliances, along with vaulted ceilings and floor-to-ceiling windows that fill your apartment with natural light.</p><p>Step into a world of comfort with in-unit amenities, including a washer and dryer, dishwashers, and private balconies* that offer stunning views and the perfect spot for relaxation. For those who enjoy an active lifestyle, our fitness center is equipped with cardio machines and free weights, while the community lounge area provides a great space to connect with neighbors, complete with complimentary Wi-Fi.</p><p>Safety and convenience are paramount at FortyOne 11, featuring a secure building entry system, gated and off-street parking, and package lockers for hassle-free deliveries. Enjoy the lush landscapes of nearby parks.</p><p>Experience modern living at its finest in Portland. Don't miss your chance to be part of our welcoming community. Find your new home today — browse our availability or schedule a tour to visit FortyOne 11.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_company_name\"></span> logo</p>"
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_name\"></span> logo, <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>"
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166803/01a0f8c9-221f-7498-be1f-ab85f7304521.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two adorable dogs relaxing on pillows on a cozy leather sofa indoors."
      }
    }
  },
  "accessibilityhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166806/019f394d-e266-7019-a3e8-b1ae11cfd18f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of the Forty One Eleven apartment building with large windows and signage."
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019fa54f-b73e-744e-b734-7243903d3fb4.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two adorable dogs relaxing on pillows on a cozy leather sofa indoors."
      }
    }
  },
  "applynowhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d20b7-815d-745e-a281-862b999b6a41.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright living room with large windows, beige sofa, glass coffee table, and a potted plant."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394d-e266-7019-a3e8-b1ae11cfd18f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of the Forty One Eleven apartment building with large windows and signage at FortyOne 11 in Portland, OR."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394d-d879-7316-a6f0-c9b193b87d03.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances and a large window overlooking trees."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019fa54c-0839-74e9-9bb5-defb6029a16b.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A cozy orange tabby cat being lovingly held and petted indoors."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-5333-74ed-8d43-79d8b103870b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with treadmills, stationary bikes, weight machines, punching bag, and shelving."
      }
    }
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-e3b9-77d8-9c95-84955f7e67f0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room in a modern apartment with large windows, mustard sofa, glass coffee table, and a TV."
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-e353-7004-a2fb-f3a149a38850.webp"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-689a-72fd-a499-6e59297043e2.webp"
      }
    }
  },
  "floorplanslist.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d20b7-815d-745e-a281-862b999b6a41.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d48aa-cfce-7253-8a99-65ef5a6cd71a.webp"
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-0b38-7774-8134-1b918e5553f9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern apartment building exterior at sunset with car light trails on the street."
      }
    }
  },
  "interactivemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-87ff-729e-be43-dffbc9097fa7.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior aerial view of a modern apartment building surrounded by trees and residential homes at FortyOne 11 in Portland, OR."
      }
    }
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": 11,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019fa54c-a668-730d-934e-ce7b4854d957.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "People crossing a city street at a crosswalk at dusk."
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019fa54c-0839-74e9-9bb5-defb6029a16b.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A person gently petting an orange tabby cat."
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-0bf7-718d-a31e-3bc7e7794d1b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern apartment building exterior with dramatic sunset sky and street view."
      }
    }
  },
  "privacypolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-57a3-7750-a384-c7a2ff9844be.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern apartment building exterior with wood and concrete accents and large windows at FortyOne 11 in Portland, OR."
      }
    }
  },
  "propertyoverview.lifestyle_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019fa54c-a4a5-7398-baad-ddb56b3b3e31.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A smiling young woman in a summer dress stands next to a blue city bike with a woven tote bag."
      }
    }
  },
  "propertyoverview.lifestyle_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019fa54e-437f-7196-b195-3c626d8fa7bf.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A person petting a dachshund on the grass."
      }
    }
  },
  "propertyoverview.slide_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-0b38-7774-8134-1b918e5553f9.webp"
      }
    }
  },
  "propertyoverview.slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394d-e266-7019-a3e8-b1ae11cfd18f.webp"
      }
    }
  },
  "propertyoverview.slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d20b7-815d-745e-a281-862b999b6a41.webp"
      }
    }
  },
  "propertyoverview.slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-5500-732f-b419-d1decb482901.webp"
      }
    }
  },
  "propertyoverview.slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-5333-74ed-8d43-79d8b103870b.webp"
      }
    }
  },
  "propertyoverview.slide_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166806/019f394e-7c11-774c-854b-ec495b2c52b5.webp"
      }
    }
  },
  "propertyoverview.slide_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166806/019d02d1-e353-7004-a2fb-f3a149a38850.webp"
      }
    }
  },
  "propertyoverview.slide_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-55a3-7150-9b8c-537d030fc188.webp"
      }
    }
  },
  "residentaccesshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-55a3-7150-9b8c-537d030fc188.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Lobby area with modern seating and a reception desk at Fortyone 11."
      }
    }
  },
  "reviewshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166806/019fa54c-a4a5-7398-baad-ddb56b3b3e31.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A smiling young woman in a summer dress stands next to a blue city bike with a woven tote bag."
      }
    }
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019f394e-55a3-7150-9b8c-537d030fc188.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Lobby area with modern seating and a reception desk at Fortyone 11."
      }
    }
  },
  "sitemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166806/019d02d1-e411-72bc-aa54-229e273e0408.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern apartment building exterior with gray and yellow accents under a clear blue sky."
      }
    }
  },
  "thankyouhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166806/019fa54c-a4a5-7398-baad-ddb56b3b3e31.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A smiling young woman in a summer dress stands next to a blue city bike with a woven tote bag."
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166806/019d02d1-e3b9-77d8-9c95-84955f7e67f0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright FortyOne 11 apartment living room with a mustard sofa, glass coffee table, and expansive windows filling the space with natural light."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": 6,
    "hiddenIds": [
      "custom_8929e13a-3a35-4374-a74d-c00781b68d17",
      "custom_893b73e6-83e3-4fef-89fb-a97d46f7f402",
      "custom_1ed37671-dc07-44bc-91c7-4f6d180149fe",
      "custom_4bcf36be-922f-4aff-b614-f1a27d49e658",
      "custom_1e2862bf-d0d2-44d4-a48e-03934bc8daff",
      "custom_9ff549cd-fdde-411a-8996-908348d45092",
      "custom_d7010331-a61b-430b-921a-67c3536b7038",
      "custom_e0b54e8b-f58f-46c4-87ae-e04c97e33597",
      "custom_f0376de7-8e80-4327-86ff-2eb86d615bba"
    ],
    "orderedIds": [
      "custom_2f735205-945d-47c9-8516-7d91a9c7a0bc",
      "custom_e122c284-c86f-42cc-8234-6cb4e66e6757",
      "custom_bd69b837-b0b3-4506-a236-1e085195d4f4",
      "custom_bc29b4de-2bde-4c11-9b7f-8301d63d7223",
      "custom_27af865d-0f49-4773-83b3-7fda824c464a",
      "custom_a0bb09dd-6c77-47db-8c7b-bff33971aed1",
      "custom_adc665e5-4e4f-4936-83ab-490c25cbc94f",
      "custom_f64a31f0-47d6-42bc-8ff5-b8c1785e6650",
      "custom_335cd0cc-420d-42ec-83d0-3ed450225597",
      "custom_1ed37671-dc07-44bc-91c7-4f6d180149fe",
      "custom_893b73e6-83e3-4fef-89fb-a97d46f7f402",
      "custom_8929e13a-3a35-4374-a74d-c00781b68d17",
      "custom_4bcf36be-922f-4aff-b614-f1a27d49e658",
      "custom_1e2862bf-d0d2-44d4-a48e-03934bc8daff",
      "custom_9ff549cd-fdde-411a-8996-908348d45092",
      "custom_f0376de7-8e80-4327-86ff-2eb86d615bba",
      "custom_e0b54e8b-f58f-46c4-87ae-e04c97e33597",
      "custom_d7010331-a61b-430b-921a-67c3536b7038",
      "custom_a0b174de-2912-4509-84c3-1b896b0fd3ad",
      "custom_327a0e57-f6c7-4ec1-95ee-f7c8caaa3f96",
      "custom_d396a78f-35fb-4fc5-90d2-3dc158c80566",
      "custom_63660cea-ad4d-45ee-87c5-51d3921c7d3d",
      "custom_5131dbc1-4a6c-4363-80e6-c8965936d2cb",
      "custom_a0656d99-7c27-416c-b562-fa5f4f3a3fac",
      "custom_012ee784-3c7d-4af0-bb34-30518adc1ee5",
      "custom_c70c841e-2941-47a5-86a7-fa82f2058521",
      "custom_e75b74d8-520d-4cda-8581-2c2917032bf9",
      "custom_5530e387-7953-4100-996a-0f6dc46fb789",
      "custom_982ac353-78d7-411b-ad36-9b1feca6681b",
      "custom_1fa04a23-2d15-4b25-9ce0-c90babed88c8",
      "custom_a4da0564-3478-410a-b628-b691b47d6c45",
      "custom_8b108272-874b-4504-9aa5-e9b0fb4fb1f5",
      "custom_28a84343-05f5-4fb6-b049-efe13e4424ba",
      "custom_2647dd3c-8e20-4a19-aa34-c8df43fd2932",
      "custom_ddee602a-dd73-44de-ba51-0859be74e71a",
      "custom_279f8cef-1b8e-434d-9c0d-cd4e3f138ae6",
      "custom_4c3d646c-d4f7-4f1a-bad5-d13a216e7abc",
      "custom_0e2def46-7298-4976-8f85-0ead8bb45af7",
      "custom_744913de-7170-4eab-bd92-f7a3842e554e",
      "custom_94a92367-1ca5-4bf2-8ace-eba631bd7f6a",
      "custom_02752621-df9f-46f2-aeba-2d63d7022c75",
      "custom_88a39bea-d1ec-4fa3-8ff3-85d3e380da00",
      "custom_1efe5cb6-bea3-476a-85e1-85d0c8bf9bce",
      "custom_80c9cbd5-9654-4d80-8100-3e14ed93a8e1",
      "custom_53feb547-1146-43a2-8b4e-f75594972d04",
      "custom_7a3dc629-db86-46c4-a024-7b09ec0bfd48"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.apartmentPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_63660cea-ad4d-45ee-87c5-51d3921c7d3d",
      "custom_f64a31f0-47d6-42bc-8ff5-b8c1785e6650",
      "custom_e122c284-c86f-42cc-8234-6cb4e66e6757",
      "custom_bd69b837-b0b3-4506-a236-1e085195d4f4",
      "custom_27af865d-0f49-4773-83b3-7fda824c464a",
      "custom_1ed37671-dc07-44bc-91c7-4f6d180149fe",
      "custom_2f735205-945d-47c9-8516-7d91a9c7a0bc",
      "custom_893b73e6-83e3-4fef-89fb-a97d46f7f402",
      "custom_8929e13a-3a35-4374-a74d-c00781b68d17",
      "custom_fdd69355-50f7-4c6c-a5cd-176fb924cc7f",
      "custom_335cd0cc-420d-42ec-83d0-3ed450225597",
      "custom_4bcf36be-922f-4aff-b614-f1a27d49e658",
      "custom_1e2862bf-d0d2-44d4-a48e-03934bc8daff",
      "custom_9ff549cd-fdde-411a-8996-908348d45092",
      "custom_f0376de7-8e80-4327-86ff-2eb86d615bba",
      "custom_ac676dc8-c470-48e6-9fd3-cc9f7dd27f07",
      "custom_e0b54e8b-f58f-46c4-87ae-e04c97e33597",
      "custom_d7010331-a61b-430b-921a-67c3536b7038",
      "custom_0a72ab9e-ccec-4300-843e-13bed23b50bb",
      "custom_01d2a268-e331-4a65-82d1-af07cd9a004e",
      "custom_39993bde-8617-4f1d-8211-c21f81fcb174",
      "custom_5131dbc1-4a6c-4363-80e6-c8965936d2cb",
      "custom_012ee784-3c7d-4af0-bb34-30518adc1ee5",
      "custom_5530e387-7953-4100-996a-0f6dc46fb789",
      "custom_982ac353-78d7-411b-ad36-9b1feca6681b",
      "custom_8b108272-874b-4504-9aa5-e9b0fb4fb1f5",
      "custom_3410d54c-9473-408e-9a25-e397529c297b",
      "custom_ed0aa8aa-c50a-40e2-92b0-42f5effc5360",
      "custom_1ad3b03c-c770-4749-9d8d-830462d9ed2e",
      "custom_4846a021-f029-4761-99da-19cc883ec539",
      "custom_279f8cef-1b8e-434d-9c0d-cd4e3f138ae6",
      "custom_4c3d646c-d4f7-4f1a-bad5-d13a216e7abc",
      "custom_5e320a77-31c9-4227-acde-90bd61addeee",
      "custom_0e2def46-7298-4976-8f85-0ead8bb45af7",
      "custom_88a39bea-d1ec-4fa3-8ff3-85d3e380da00",
      "custom_53feb547-1146-43a2-8b4e-f75594972d04",
      "custom_7a3dc629-db86-46c4-a024-7b09ec0bfd48"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_d30e188f-547f-43d4-91f2-3f9d07bc0b21",
      "custom_5fcdc0c9-e5f9-4b37-82cb-6dc6ea1b928f",
      "custom_c8a4bd99-3dc7-4004-b5a7-ac642a4def06",
      "custom_dfc2f485-f695-40a8-bc67-bb9b0e19444d",
      "custom_d396a78f-35fb-4fc5-90d2-3dc158c80566",
      "custom_a0bb09dd-6c77-47db-8c7b-bff33971aed1",
      "custom_1fa04a23-2d15-4b25-9ce0-c90babed88c8",
      "custom_f2e57788-ce78-4e95-95a8-37a8343a5414",
      "custom_f5f3be4b-683e-4a88-b7d3-04098a1fca8a",
      "custom_ba8f870f-ffe4-457c-82e6-fe19a1d9b1c4",
      "custom_16e78d34-ef51-4377-81f5-f3d470f00b55",
      "custom_6c2639b2-68ce-4fc3-8396-1e86b37f2753",
      "custom_845d4125-c3f6-446a-8658-3a5e0105ee49",
      "custom_361b2cd1-b7c7-44c0-a5f3-d2c7aae6234d",
      "custom_9676dd84-8695-416e-b269-fee2c9e7af07",
      "custom_a0b174de-2912-4509-84c3-1b896b0fd3ad",
      "custom_327a0e57-f6c7-4ec1-95ee-f7c8caaa3f96",
      "custom_bc29b4de-2bde-4c11-9b7f-8301d63d7223",
      "custom_a0656d99-7c27-416c-b562-fa5f4f3a3fac",
      "custom_c70c841e-2941-47a5-86a7-fa82f2058521",
      "custom_e75b74d8-520d-4cda-8581-2c2917032bf9",
      "custom_da9b200a-48f7-457b-bc28-17c760ed4a73",
      "custom_a4da0564-3478-410a-b628-b691b47d6c45",
      "custom_adc665e5-4e4f-4936-83ab-490c25cbc94f",
      "custom_28a84343-05f5-4fb6-b049-efe13e4424ba",
      "custom_2647dd3c-8e20-4a19-aa34-c8df43fd2932",
      "custom_ddee602a-dd73-44de-ba51-0859be74e71a",
      "custom_744913de-7170-4eab-bd92-f7a3842e554e",
      "custom_94a92367-1ca5-4bf2-8ace-eba631bd7f6a",
      "custom_02752621-df9f-46f2-aeba-2d63d7022c75",
      "custom_03b08b05-4d78-49e2-89e9-478c17a6a319",
      "custom_1efe5cb6-bea3-476a-85e1-85d0c8bf9bce",
      "custom_80c9cbd5-9654-4d80-8100-3e14ed93a8e1"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_a4da0564-3478-410a-b628-b691b47d6c45",
      "custom_adc665e5-4e4f-4936-83ab-490c25cbc94f",
      "custom_a0bb09dd-6c77-47db-8c7b-bff33971aed1",
      "custom_ddee602a-dd73-44de-ba51-0859be74e71a",
      "custom_327a0e57-f6c7-4ec1-95ee-f7c8caaa3f96",
      "custom_2647dd3c-8e20-4a19-aa34-c8df43fd2932"
    ],
    "orderedIds": [
      "custom_28a84343-05f5-4fb6-b049-efe13e4424ba",
      "custom_94a92367-1ca5-4bf2-8ace-eba631bd7f6a",
      "custom_a0b174de-2912-4509-84c3-1b896b0fd3ad",
      "custom_744913de-7170-4eab-bd92-f7a3842e554e",
      "custom_e75b74d8-520d-4cda-8581-2c2917032bf9",
      "custom_2647dd3c-8e20-4a19-aa34-c8df43fd2932",
      "custom_327a0e57-f6c7-4ec1-95ee-f7c8caaa3f96",
      "custom_ddee602a-dd73-44de-ba51-0859be74e71a",
      "custom_a0bb09dd-6c77-47db-8c7b-bff33971aed1",
      "custom_c70c841e-2941-47a5-86a7-fa82f2058521",
      "custom_80c9cbd5-9654-4d80-8100-3e14ed93a8e1",
      "custom_1fa04a23-2d15-4b25-9ce0-c90babed88c8",
      "custom_a0656d99-7c27-416c-b562-fa5f4f3a3fac",
      "custom_adc665e5-4e4f-4936-83ab-490c25cbc94f",
      "custom_1efe5cb6-bea3-476a-85e1-85d0c8bf9bce",
      "custom_02752621-df9f-46f2-aeba-2d63d7022c75",
      "custom_a4da0564-3478-410a-b628-b691b47d6c45",
      "custom_bc29b4de-2bde-4c11-9b7f-8301d63d7223",
      "custom_d396a78f-35fb-4fc5-90d2-3dc158c80566",
      "custom_17a8111e-019f-4203-8121-02fd4f669e17",
      "custom_5a1d44f7-8b1c-4bd6-b9aa-2c2646f12c6b",
      "custom_720add2c-bbc5-42ee-8044-ed405ab5270e",
      "custom_6ab9c8f2-50c1-44cf-91d9-dfe3e45c0ae9",
      "custom_e122c284-c86f-42cc-8234-6cb4e66e6757",
      "custom_bd69b837-b0b3-4506-a236-1e085195d4f4",
      "custom_f64a31f0-47d6-42bc-8ff5-b8c1785e6650",
      "custom_08607c46-6037-465d-8a1f-1495804abb2c",
      "custom_91842e6b-56a3-4660-8da7-76d729b51fc8",
      "custom_27af865d-0f49-4773-83b3-7fda824c464a",
      "custom_2f735205-945d-47c9-8516-7d91a9c7a0bc",
      "custom_f3916a7a-5286-407e-a025-c9f96f627f71",
      "custom_831b7713-2649-46d7-adb4-b89d6866fdfc",
      "custom_0655288a-76d6-4046-81f3-be713044bfb3",
      "custom_8baeed1a-2bbe-4135-b53d-0eac0d82148a"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0
    },
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "engrain-sitemap",
      "blockId": "engrain-sitemap",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  }
};
